import { SIZE_FAMILIES } from "constants/action-types";
import { handleActions } from "redux-actions";
import { ISizeFamily } from "../containers/management/management-types";

const initialState = {
    families: [],
    isAdding: false,
    isDeleting: false,
    isFetching: false,
    isUpdating: false,
    familiesError: undefined,
};

interface IState {
    families: ISizeFamily[];
    isAdding: boolean;
    isFetching: boolean;
    isUpdating: boolean;
    familiesError: any;
}

export const sizeFamilies = handleActions(
    {
        [SIZE_FAMILIES.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [SIZE_FAMILIES.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                families: payload,
                isFetching: false,
            };
        },
        [SIZE_FAMILIES.FETCH.ERROR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetching: false,
                familiesError: payload.error,
            };
        },
        [SIZE_FAMILIES.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [SIZE_FAMILIES.CREATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    isAdding: false,
                    familiesError: error,
                };
            }
            return {
                ...state,
                families: [...state.families, payload],
                isAdding: false,
            };
        },
        [SIZE_FAMILIES.DELETE.START]: (state: IState) => {
            return {
                ...state,
                isDeleting: true,
            };
        },
        [SIZE_FAMILIES.DELETE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isDeleting: false,
                };
            }
            const { _id } = payload;
            return {
                ...state,
                families: state.families.filter((f) => f._id !== _id),
                isDeleting: false,
            };
        },
        [SIZE_FAMILIES.UPDATE.START]: (state: IState) => {
            return {
                ...state,
                isUpdating: true,
            };
        },
        [SIZE_FAMILIES.UPDATE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isUpdating: false,
                };
            }
            const families = state.families.slice();
            const index = families.findIndex((f) => f._id === payload._id);
            families.splice(index, 1, payload);

            return {
                ...state,
                families,
                isUpdating: false,
            };
        },
    },
    initialState,
);
